module.exports = __webpack_public_path__ + "static/media/access-bank-wallet.bdf1d195.svg";